import imageUrlBuilder from '@sanity/image-url'
import client from '../../sanity'   // however you import yours

const builder = imageUrlBuilder(client)

export function urlFor(source) {
  return builder.image(source)
}
